import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Button, ButtonToolbar, PanelGroup} from 'react-bootstrap'
import {NEW_WORKFLOW} from '../models'
import i18n from '../i18n'
import WorkflowPanel from './WorkflowPanel'
import UpdateIdentifiedRequestsModal from './UpdateIdentifiedRequestsModal'
import UpdateWorkflowLabelModal from './UpdateWorkflowLabelModal'
import RemoveWorkflowModal from './RemoveWorkflowModal'

function modalName(result) {
    switch (result) {
        case 'UpdateIdentifiedRequests':
            return 'UpdateIdentifiedRequestsModal'
        case 'UpdateWorkflowLabel':
            return 'UpdateWorkflowLabelModal'
        case 'RemoveWorkflow':
            return 'RemoveWorkflowModal'
        default:
            return null
    }
}

class WorkflowPanelGroup extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    _openPanel(key) {
        const {activeKey} = this.state

        const nextActiveKey = activeKey != key && key || null
        this.setState({activeKey: nextActiveKey})
    }

    _openModal(event, result, activeWorkflow) {
        if (event) {
            event.preventDefault()
        }

        const openedModal = modalName(result)
        this.setState({openedModal, activeWorkflow})
    }

    _closeModal(event) {
        if (event) {
            event.preventDefault()
        }

        this.setState({openedModal: null})
    }

    render() {
        const {dispatch, stream} = this.props
        const {activeKey, openedModal, activeWorkflow} = this.state

        return (
            <div>
                <PanelGroup accordion
                    activeKey={activeKey}
                    onSelect={(k) => this._openPanel(k)}>
                    {stream.map((workflow) => (
                        <WorkflowPanel
                            key={workflow.uid}
                            eventKey={workflow.uid}
                            workflow={workflow}
                            onSubmit={(e, r, w) => this._openModal(e, r, w)} />
                    ))}
                    {activeKey == 'new' && (
                        <WorkflowPanel
                            eventKey='new'
                            workflow={NEW_WORKFLOW}
                            onSubmit={(e, r, w) => this._openModal(e, r, w)} />
                    )}
                </PanelGroup>
                {activeKey != 'new' && (
                    <ButtonToolbar>
                        <Button
                            bsStyle='primary'
                            bsSize='large'
                            onClick={() => this._openPanel('new')}>
                            {i18n.newWorkflow}
                        </Button>
                    </ButtonToolbar>
                )}
                {activeWorkflow && (
                    <UpdateIdentifiedRequestsModal
                        show={openedModal == 'UpdateIdentifiedRequestsModal'}
                        onHide={(e) => this._closeModal(e)}
                        workflow={activeWorkflow} />
                )}
                {activeWorkflow && (
                    <UpdateWorkflowLabelModal
                        show={openedModal == 'UpdateWorkflowLabelModal'}
                        onHide={(e) => this._closeModal(e)}
                        workflow={activeWorkflow} />
                )}
                {activeWorkflow && (
                    <RemoveWorkflowModal
                        show={openedModal == 'RemoveWorkflowModal'}
                        onHide={(e) => this._closeModal(e)}
                        workflow={activeWorkflow} />
                )}
            </div>
        )
    }
}

WorkflowPanelGroup = connect((state) => ({
    stream: state.workflow.stream
}))(WorkflowPanelGroup)

export default WorkflowPanelGroup


// WEBPACK FOOTER //
// ./lib/workflow/components/WorkflowPanelGroup.js